import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import withMixpanel, { TRAP_DATA_HEATMAP_ON } from 'utils/mixpanel'
import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose'

import * as mapModule from 'modules/map'

import { HEATMAP_COLORS, ZOOM_MIN, ZOOM_MAX, ZOOM_MIN_DEFAULT } from 'constants/maps'

export default compose(
  withMixpanel,
  connect(
    (state) => {
      return {
        data: idx(state, _ => _.map.data),
        activeTrap: idx(state, _ => _.map.activeTrap),
        activeGroup: idx(state, _ => _.map.activeGroup),
        focusedTrap: idx(state, _ => _.map.focusedTrap),
        focusedGroup: idx(state, _ => _.map.focusedGroup),
        organisation: idx(state, _ => _.organisation.selected),
        showArchivedTraps: idx(state, _ => _.ui.showArchived)
      }
    },
    (dispatch) => {
      const actions = {
        ...mapModule,
      }
      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    ({ data }) => ({
      loaded: !!data,
      infoTipLabel: '',
      heatmapOpen: false,
      tilesLoaded: false,
      mapTypeId: 'satellite',
    }),
    {
      toggleCheckbox: () => event => ({
        rememberMe: event.target.checked
      }),
      onChange: state => changeValues => ({
        ...state,
        ...changeValues
      }),
      setDefaultBounds: () => defaultBounds => ({
        defaultBounds
      }),
      onTilesLoaded: () => () => ({
        loaded: true
      }),
      toggleHeatmap: () => value => ({
        heatmapOpen: value
      }),
    }
  ),
  withHandlers({
    onApiLoad: ({ data, setDefaultBounds }) => (map, maps) => {
      this.map = map
      this.maps = maps
      const bounds = new maps.LatLngBounds()
      bounds.extend({ lat: data.minLatitude, lng: data.minLongitude })
      bounds.extend({ lat: data.maxLatitude, lng: data.maxLongitude })

      setTimeout(() => {
        map.fitBounds(bounds)
      
        maps.event.addListenerOnce(map, 'zoom_changed', () => {
          if (map.getZoom() > ZOOM_MIN_DEFAULT) {
            map.setZoom(ZOOM_MIN_DEFAULT - 2)
          }
        })
        setDefaultBounds(bounds)
      }, 0)
    },
    handleMapZoom: () => (value) => {
      const zoom = this.map.getZoom()
      if (value === -1 && zoom + value > ZOOM_MAX) {
        this.map.setZoom(zoom + value)
      } else if (value === 1 && zoom + value < ZOOM_MIN) {
        this.map.setZoom(zoom + value)
      }
    },
    handleMapReset: ({ defaultBounds, actions }) => () => {
      this.map.fitBounds(defaultBounds)
      actions.resetMapState()
    },
    getMapOptions: ({ mapTypeId }) => () => {
      return {
        mapTypeId,
        scrollwheel: false,
        disableDefaultUI: true,
      }
    },
    toggleHeatmap: ({
      track, heatmapOpen, data, toggleHeatmap 
    }) => (value) => {
      const { maps, map } = this

      if (!heatmapOpen) {
        track(TRAP_DATA_HEATMAP_ON)
      }

      if (this.heatmap) {
        this.heatmap.setMap(heatmapOpen ? null : map)
        toggleHeatmap(value)
      } else if (data) {
        const gradient = ['rgba(0, 26, 57, 0.55)', ...HEATMAP_COLORS]
        const newHeatMap = new maps.visualization.HeatmapLayer({
          data: data.groupLineDetails.map((point) => {
            return point.totalKills > 0 ? {
              location: new maps.LatLng(point.latitude, point.longitude),
              weight: point.totalKills / 3,
            } : null
          })
        })
        newHeatMap.set('gradient', newHeatMap.get('gradient') ? null : gradient)
        newHeatMap.set('radius', 15)
        newHeatMap.set('maxIntensity', 11)
        newHeatMap.set('dissipating', true)
        newHeatMap.setMap(map)
        this.heatmap = newHeatMap
        toggleHeatmap(value)
      }
    },
    handleTrapClick: ({ onChange: setInfoTipState }) => ({ pageX, pageY }, trap) => {
      setInfoTipState({
        infoTipTrap: trap,
        infoTipX: pageX,
        infoTipY: pageY - 209 // height of dashboard header
      })

      if (this.infoTipTimeout) {
        clearTimeout(this.infoTipTimeout)
      }

      this.infoTipTimeout = setTimeout(() => {
        setInfoTipState({ infoTipTrap: null, infoTipX: null, infoTipY: null })
      }, 5000)
    }
  }),
  lifecycle({
    componentDidMount() {
      const { actions, organisation, data } = this.props
      
      if (!data || !data.groupLineDetails || !data.groupLineDetails.length) {
        actions.getMapTraps(organisation)
      } else {
        actions.resetMapState()
      }
    }
  })
)



// WEBPACK FOOTER //
// ./src/components/organisms/OverviewMap/OverviewMap.enhancer.js